import {
    Card,
    CardActionArea,
    CardContent,
    CardHeader,
    ListItem,
    Typography,
} from "@material-ui/core";
import ArrowForward from "@material-ui/icons/ArrowForward";
import React from "react";
import SectionView from "./SectionView";
import styled from "styled-components";
import Course from "../Models/Course";
import UpNextItem from "../Models/UpNextItem";
import useUpNextItem from "../Context/Consumers/useUpNextItem";

interface UpNextSectionProps {
    onClick: (course: Course) => void
    disableGutters: boolean;
}

interface UpNextViewProps {
    onClick: (course: Course) => void;
    upNextItem: UpNextItem;
}

const UpNextViewContainer = styled(Card)`
  width: 100%;
  margin-top: 8px;
  color: white;
  background: #046A38;
`;

const UpNextView = (props: UpNextViewProps) => {
    const {onClick, upNextItem} = props;

    return (
        <UpNextViewContainer >
            <CardActionArea onClick={() => onClick(upNextItem.course)}>
                <CardHeader
                    title={<Typography>{'UP NEXT'}</Typography>}
                    disableTypography
                    action={
                        <ArrowForward />
                    }
                />
                <CardContent>
                    <Typography variant={'h5'}>
                        {upNextItem.course.title}
                    </Typography>
                    <Typography>
                        {upNextItem.date}
                    </Typography>
                    <Typography>
                        {upNextItem.location}
                    </Typography>
                </CardContent>
            </CardActionArea>
        </UpNextViewContainer>
    );
};


const UpNextSection = (props: UpNextSectionProps) => {
    const {onClick, disableGutters} = props;
    const upNextItem: any = useUpNextItem();

    return (
        <>
            {upNextItem &&
                <SectionView>
                    <ListItem disableGutters>
                        <UpNextView onClick={onClick} upNextItem={upNextItem}/>
                    </ListItem>
                </SectionView>
            }
        </>
    );
};
export default UpNextSection;
